import { callAPi } from "./api";

// Existing services for become member URLs
const create = (data) => callAPi.post("/admin/become-member", data);
const edit = (data, id) => callAPi.patch(`/admin/become-member/${id}`, data);
const get = () => callAPi.get("/become-member");
const getByID = (id) => callAPi.get(`/become-member/${id}`);
const deleteAnnouncement = (id) => callAPi.delete(`/admin/become-member/${id}`);

// Existing services for membership applications
const submitApplication = (data) => callAPi.post("/membership-applications", data);
const getApplications = (params) => callAPi.get("/admin/membership-applications", { params });
const getApplicationByID = (id) => callAPi.get(`/admin/membership-applications/${id}`);
const deleteApplication = (id) => callAPi.delete(`/admin/membership-applications/${id}`);

// NEW — Admin registers a member on behalf of someone (returns PDF blob)
const adminRegisterMember = (data) =>
  callAPi.post("/admin/membership-applications", data, { responseType: "blob" });

// NEW — Admin edits an existing application and regenerates PDF (returns PDF blob)
const adminUpdateMember = (id, data) =>
  callAPi.put(`/admin/membership-applications/${id}`, data, { responseType: "blob" });

const becomeMemberServices = {
  create,
  edit,
  get,
  deleteAnnouncement,
  getByID,
  // Existing application services
  submitApplication,
  getApplications,
  getApplicationByID,
  deleteApplication,
  // New admin services
  adminRegisterMember,
  adminUpdateMember,
};

export default becomeMemberServices;